import * as THREE from 'three';

async function initializeWithDeadline(renderer, milliseconds) {
  let timeoutId;
  try {
    await Promise.race([
      renderer.init(),
      new Promise((_, reject) => {
        timeoutId = window.setTimeout(
          () => reject(new Error(`WebGPU initialization exceeded ${milliseconds}ms`)),
          milliseconds
        );
      })
    ]);
  } finally {
    window.clearTimeout(timeoutId);
  }
}

export async function createRenderer(canvas) {
  if (
    navigator.gpu &&
    !navigator.webdriver &&
    !new URLSearchParams(window.location.search).has('webgl')
  ) {
    try {
      const { WebGPURenderer } = await import('three/webgpu');
      const renderer = new WebGPURenderer({ canvas, antialias: true, alpha: false });
      await initializeWithDeadline(renderer, 2200);
      renderer.userData = renderer.userData ?? {};
      renderer.userData.backend = 'WebGPU';
      return renderer;
    } catch (error) {
      console.warn('WebGPU initialization failed; using WebGL.', error);
    }
  }

  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
    powerPreference: 'high-performance'
  });
  renderer.userData = renderer.userData ?? {};
  renderer.userData.backend = 'WebGL 2';
  return renderer;
}
